// extracted by mini-css-extract-plugin
export default {"btn":"startover_btn__6HRMw","btn--start-over":"startover_btn--start-over__QyOTZ"};